import { Paper, Text, Flex, Button } from '@mantine/core';
import { IconChevronRight } from '@tabler/icons-react';
import { Link } from 'react-router-dom';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import type { CalendarEvent } from 'src/meetings/models';
import { getParticipantFullName } from '../utils/event-utils';
import { EventTime } from './EventTime';

type Props = {
  event: CalendarEvent;
};

export const PastEventCard = ({ event }: Props) => {
  const firstClientParticipant = event.eventParticipants.find(
    p => p.participant.participantType === 'CLIENT',
  );
  const clientName = getParticipantFullName(firstClientParticipant) ?? 'Unknown Client';

  return (
    <Paper variant="card">
      <Flex justify="space-between" align="center">
        <Text size="sm" fw={FONT_WEIGHTS.semibold} c="gray.7">
          {clientName}
        </Text>
        <EventTime
          scheduledStartAt={event.scheduledStartAt}
          scheduledEndAt={event.scheduledEndAt}
          platform={event.meetingPlatform}
        />
      </Flex>

      <Link
        to={`/meetings/${event.id}/summary`}
        style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
      >
        <Text size="lg" fw={FONT_WEIGHTS.semibold} c="gray.10" mt="xxxs">
          {event.title}
        </Text>

        <Text size="sm" fw={FONT_WEIGHTS.medium} c="gray.6" mt="xxs" lineClamp={2}>
          {event.summary}
        </Text>
      </Link>

      <Flex
        justify="space-between"
        align="center"
        mt="sm"
        pt="xs"
        px="sm"
        mx="-sm"
        style={{ borderTop: '1px solid #f2f2f2' }}
      >
        <Button
          component={Link}
          to={`/meetings/${event.id}/meeting-note`}
          variant="text"
          c="brand.6"
        >
          Generate meeting note
        </Button>
        <Button
          component={Link}
          to={`/meetings/${event.id}/summary`}
          variant="text"
          c="brand.6"
          rightSection={<IconChevronRight size={16} />}
        >
          More actions
        </Button>
      </Flex>
    </Paper>
  );
};
